import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

export const useAuth = () => {
  const dispatch = useDispatch();
  const localStorageUser = localStorage.getItem("user");
  const [isAuth, setIsAuth] = useState(!!localStorageUser);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    const publicRoutes = [
      "/reset-password",
      "/reset-password-request",
      "/home",
      "/login",
      "/user-register",
      "/terms",
      "/insights",
      "/contactUs",
      "/meet-community",
    ];
    if (!localStorageUser) {
      setIsAuth(false);

      !publicRoutes.includes(pathname) && navigate("/");
    }

    if (localStorageUser) {
      setIsAuth(true);
    }
  }, [dispatch, navigate, localStorageUser, pathname]);

  return { isAuth };
};
